import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  REGISTER_USER_RESET,
  REGISTER_USER_RESEND,
  REGISTER_USER_API_ERROR,
  FETCH_COUNTRY,
  RESET_REGISTER_RESPONSE_MSG,
  SET_COUNTRY_LIST,
  FETCH_COUNTRY_LIST,
  FETCH_COUNTRY_AND_STATES_LIST,
  SET_COUNTRY_AND_STATES_LIST,
} from "./actionTypes"

export const registerUser = (user, history) => {
  return {
    type: REGISTER_USER,
    payload: { user, history },
  }
}

export const registerUserSuccessful = user => {
  return {
    type: REGISTER_USER_SUCCESSFUL,
    payload: user,
  }
}

export const registerUserFailed = user => {
  return {
    type: REGISTER_USER_FAILED,
    payload: user,
  }
}
export const ResendRegisterUser = (user, history) => {
  return {
    type: REGISTER_USER_RESEND,
    payload: { user, history },
  }
}

export const registerUserReset = user => {
  return {
    type: REGISTER_USER_RESET,
  }
}

export const fetchCountryList = (user, history) => {
  return {
    type: FETCH_COUNTRY_LIST,
    payload: { user, history },
  }
}

export const registerUserApiError = user => {
  return {
    type: REGISTER_USER_API_ERROR,
  }
}

export const resetRegisterResponseMsg = (payload) => {
  return {
    type: RESET_REGISTER_RESPONSE_MSG,
    payload: payload,
  }
}

export const setCountryList = (paylod) => {
  return {
    type: SET_COUNTRY_LIST,
    payload: paylod
  }
}
export const fetchCountryAndStatesList = (user, history) => {
  return {
    type: FETCH_COUNTRY_AND_STATES_LIST,
    payload: { user, history },
  }
}

export const setCountryAndStatesList = (paylod) => {
  return {
    type: SET_COUNTRY_AND_STATES_LIST,
    payload: paylod
  }
}
